/**
 * URL validation utilities
 */

/**
 * Validates if a URL is a valid Google Docs URL
 * @param {string} url - The URL to validate
 * @returns {boolean} - True if valid Google Docs URL
 */
export const isValidGoogleDocsUrl = (url) => {
  if (!url || typeof url !== 'string') {
    return false
  }
  
  return url.includes('docs.google.com/document') || url.includes('drive.google.com/file')
}

/**
 * Validates if a URL is a valid Google Sheets URL
 * @param {string} url - The URL to validate
 * @returns {boolean} - True if valid Google Sheets URL
 */
export const isValidGoogleSheetsUrl = (url) => {
  if (!url || typeof url !== 'string') {
    return false
  }
  
  return url.includes('docs.google.com/spreadsheets')
}

/**
 * General URL validation
 * @param {string} url - The URL to validate
 * @returns {boolean} - True if valid URL format
 */
export const isValidUrl = (url) => {
  if (!url || typeof url !== 'string') {
    return false
  }
  
  try {
    new URL(url)
    return true
  } catch {
    return false
  }
}